module.exports = "images/our-secret-sauce_poster.jpg";